/**
 * @generated SignedSource<<afee8b34f932c6ee8f2b1c6a9f9ced9e>>
 * @relayHash c3e1d2f1050f72df266cf46d38850c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AquaNotificationLogsFilter = {
  filterActionable?: boolean | null;
  selectedFilters?: ReadonlyArray<string | null> | null;
};
export type NotificationLogsPageQuery$variables = {
  cloudId: string;
  filterActionable?: boolean | null;
  filters?: AquaNotificationLogsFilter | null;
  notificationActionType?: string | null;
  notificationType?: string | null;
  projectId?: AGG$Long | null;
  recipientId?: string | null;
};
export type NotificationLogsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AdminEmailAuditPageBanners" | "UserInvitations">;
};
export type NotificationLogsPageQuery = {
  response: NotificationLogsPageQuery$data;
  variables: NotificationLogsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterActionable"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationActionType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "NotificationLogsPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "UserInvitations"
      },
      {
        "kind": "FragmentSpread",
        "name": "AdminEmailAuditPageBanners"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationLogsPageQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "AquaOutgoingEmailLogsQueryApi",
        "kind": "LinkedField",
        "name": "aquaOutgoingEmailLogs",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "filterActionable",
                "variableName": "filterActionable"
              },
              {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
              },
              {
                "kind": "Variable",
                "name": "notificationActionType",
                "variableName": "notificationActionType"
              },
              {
                "kind": "Variable",
                "name": "notificationType",
                "variableName": "notificationType"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              {
                "kind": "Variable",
                "name": "recipientId",
                "variableName": "recipientId"
              }
            ],
            "kind": "LinkedField",
            "name": "GetNotificationLogs",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "AquaOutgoingEmailLogConnection",
                    "kind": "LinkedField",
                    "name": "logs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AquaOutgoingEmailLogItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AquaIssueContext",
                                "kind": "LinkedField",
                                "name": "issueContext",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "key"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "webUrl"
                                      },
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "actionTimestamp"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionSubType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "deliveryType"
                              },
                              {
                                "concreteType": "AquaNotificationDetails",
                                "kind": "LinkedField",
                                "name": "notificationDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "errorKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mailboxMessage"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "hasRecipientJoined"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "email"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              (v8/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "startCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "logs(first:20)"
                  },
                  {
                    "args": (v9/*: any*/),
                    "handle": "connection",
                    "key": "aquaOutgoingEmail__logs",
                    "kind": "LinkedHandle",
                    "name": "logs"
                  }
                ],
                "type": "AquaOutgoingEmailLog"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraOutgoingEmailSettings",
            "kind": "LinkedField",
            "name": "getOutgoingEmailSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "emailSystemSettingsDisabled"
              },
              {
                "kind": "ScalarField",
                "name": "spamProtectionOnTenantApplicable"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d",
    "metadata": {},
    "name": "NotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a2d58555c4f0737281f92bf9bcba89bb";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
